import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/motion";
import { SERVICES } from "@/data/site";

const Services = () => {
  const [hover, setHover] = useState(null);

  return (
    <section id="services" className="relative py-24 md:py-36 max-w-[1600px] mx-auto px-5 md:px-10" data-testid="services-section">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <div>
          <Reveal><Overline>What We Do</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-4 font-serif text-4xl md:text-6xl lg:text-7xl font-light tracking-tight leading-none">
              A service for<br />every fabric.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-sm text-base font-light text-foreground/70 leading-relaxed">
            From daily laundry to couture restoration — one trusted address in South Delhi for all of it.
          </p>
        </Reveal>
      </div>

      {/* Floating hover image */}
      <AnimatePresence>
        {hover && (
          <motion.div
            key={hover.id}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className="pointer-events-none fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-30 w-[40vw] max-w-md aspect-[4/5] overflow-hidden hidden lg:block"
          >
            <img src={hover.image} alt={hover.title} className="w-full h-full object-cover" />
          </motion.div>
        )}
      </AnimatePresence>

      <div className="border-t border-foreground/15">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.05}>
            <div
              data-testid={`service-${s.id}`}
              onMouseEnter={() => setHover(s)}
              onMouseLeave={() => setHover(null)}
              className="group grid grid-cols-12 items-center gap-4 py-7 md:py-9 border-b border-foreground/15 cursor-default transition-colors duration-300 hover:bg-foreground/[0.03]"
            >
              <span className="col-span-2 md:col-span-1 font-mono text-sm text-foreground/40">0{i + 1}</span>
              <div className="col-span-8 md:col-span-5 flex items-center gap-4 md:gap-5">
                <img
                  src={s.image}
                  alt=""
                  className="w-14 h-14 md:w-16 md:h-16 object-cover grayscale shrink-0"
                />
                <h3 className="font-serif text-2xl md:text-4xl font-light tracking-tight group-hover:translate-x-2 transition-transform duration-300">
                  {s.title}
                </h3>
              </div>
              <p className="hidden md:block col-span-5 text-sm font-light text-foreground/75 leading-relaxed pr-8">
                {s.desc}
              </p>
              <ArrowUpRight className="col-span-2 md:col-span-1 justify-self-end text-foreground/40 group-hover:text-foreground group-hover:rotate-45 transition-all duration-300" size={24} />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Services;
